// =============================================================================
// FILE PATH : src/modules/pms/task_template/services/taskTemplateService.js
// MODULE    : PMS → Task Template
// PURPOSE   : API service for Task Template module
// =============================================================================

import axiosClient from "../../../../api/axiosClient";


// -----------------------------------------------------------------------------
// GET ALL TEMPLATES
// -----------------------------------------------------------------------------
export const getTemplates = async (params = {}) => {
  try {
    const response = await axiosClient.get("/api/pms/task-template", {
      params
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching templates:", error);
    throw error;
  }
};


// -----------------------------------------------------------------------------
// SAVE TEMPLATE (CREATE / UPDATE)
// -----------------------------------------------------------------------------
export const saveTemplate = async (data) => {
  try {
    const response = await axiosClient.post(
      "/api/pms/task-template/save",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error saving template:", error);
    throw error;
  }
};


// -----------------------------------------------------------------------------
// DELETE TEMPLATE
// -----------------------------------------------------------------------------
export const deleteTemplate = async (templateId) => {
  try {
    const response = await axiosClient.delete(
      `/api/pms/task-template/${templateId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting template:", error);
    throw error;
  }
};


// -----------------------------------------------------------------------------
// GET TEMPLATE LIBRARY (FOR DRAWER LATER)
// -----------------------------------------------------------------------------
export const getTemplateLibrary = async () => {
  try {
    const response = await axiosClient.get(
      "/api/pms/task-template/library"
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching template library:", error);
    throw error;
  }
};


// -----------------------------------------------------------------------------
// APPLY TEMPLATE (INSERT INTO WBS)
// -----------------------------------------------------------------------------
export const applyTemplate = async (data) => {
  try {
    const response = await axiosClient.post(
      "/api/pms/task-template/apply",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error applying template:", error);
    throw error;
  }
};

// -----------------------------------------------------------------------------
// GET EQUIPMENT LIST (FOR TEMPLATE FORM)
// -----------------------------------------------------------------------------
export const getEquipmentList = async () => {
  try {
    const response = await axiosClient.get(
      "/api/ppe/masters/equipment"
    );

    // API returns: { success: true, data: [...] }
    return response.data;
  } catch (error) {
    console.error("Error fetching equipment list:", error);
    throw error;
  }
};